import { createReducer, on } from '@ngrx/store';

import { DetailViewActions } from '../../actions/detail-view.actions';

import { DetailPanelActions } from './detail-panel.actions';
import { DetailPanelState, initialDetailPanelState } from './detail-panel.model';

export const detailPanelReducer = createReducer<DetailPanelState>(
  initialDetailPanelState,

  on(
    DetailPanelActions.setHasUnsavedChanges,
    (state, { hasUnsavedChanges }): DetailPanelState => ({ ...state, hasUnsavedChanges })
  ),
  on(DetailViewActions.closed, (): DetailPanelState => initialDetailPanelState)
);
